export const TEAM_MEMBER_HEADERS = [
    "Member name",
    "Email",
    "Ticket routing",
    "Actions",
];

export const TEAM_MEMBER_ACTIONS = { REMOVE_MEMBER: "REMOVE_MEMBER" };
